import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/scrollTop';
import Home from './pages/Home';
import KnowlegdeCheck from './pages/knowlegdeCheck';
import Qr from './pages/qr';
import Thumbnail from './pages/thumbnail';
import Pkdex from './pages/pkdex';
import Barcode from './pages/barcode';
import FileConverter from './pages/fileConverter';
import TextSpeech from './pages/textSpeech';
import Contact from './pages/contact';
import Privacy from './pages/privacy';
import About from './pages/about';
import Counter from './pages/counter';
import Blogs from './pages/blogs';
import Blog from './pages/blog';
import Paraphrase from './pages/paraphrase';
import GrammerFixer from './pages/grammerFixer';
import Saas from './pages/saas';
import Signup from './pages/signup';
import Login from './pages/login';
import ForgotPassword from './pages/forgot';
import Pricing from './pages/pricing';
import TextImage from './pages/textToImage';
import Checkout from './pages/checkout';
import ImageGenerator from './pages/imageGenerator';

const App = () => {
  return (
   <>
   <ScrollToTop/>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path='/KnowledgeCheck' element={<KnowlegdeCheck/>}/>
      <Route path='/qr' element={<Qr/>}/>
      <Route path='/Counter' element={<Counter/>}/>
      <Route path='/youtube-thumbnail-downloader' element={<Thumbnail/>}/>
      <Route path='/pkdex' element={<Pkdex/>}/>
      <Route path='/barcodeScan' element={<Barcode/>}/>
      <Route path='/FileConverter' element={<FileConverter/>}/>
      <Route path='/Text-to-Speech-Converter' element={<TextSpeech/>}/>
      <Route path='/contact' element={<Contact/>}/>
      <Route path='/privacyPolicy' element={<Privacy/>}/>
      <Route path='/AboutUs' element={<About/>}/>
      <Route path='/Blogs' element={<Blogs/>}/>
      <Route path='/blog/:id' element={<Blog/>}/>
      <Route path="ParapharaseAI" element={<Paraphrase/>}/>
      <Route path='GrammarFixerAI' element={<GrammerFixer/>}/>
      <Route path='/write-for-us-saas' element={<Saas/>}/>
      <Route path='/signup' element={<Signup/>}/>
      <Route path='/login' element={<Login/>}/>
      <Route path='/forgot-password' element={<ForgotPassword/>}/>
      <Route path='/tool/:id' element={<TextImage/>} />
      {/* <Route path='/pricing' element={<Pricing/>}/>
      <Route path='/checkout/:id' element={<Checkout/>}/> */}
      <Route path='/imageGenerator' element={<ImageGenerator/>}/>
    </Routes>
   </>
  );
};

export default App;
